// En desarrollo (npm start) se usa .env.development → REACT_APP_API_URL=http://localhost:3002
// En producción (npm run build) se usa .env.production → REACT_APP_API_URL=/api
// CRA carga automáticamente el archivo .env correcto según el entorno.
export const BASE_URL = process.env.REACT_APP_API_URL;
export const urlBackend = process.env.REACT_APP_API_URL;
export const port = 5002; // mantenido por compatibilidad